module.exports = __webpack_public_path__ + "img/star.59f9bd34.svg";